<template>
    <div class>
        <el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
            <el-form
                :inline="true"
                :model="agentForm"
                label-position="right"
                label-width="140px"
            >
                <!-- 资质信息 -->
                <template>
                    <div class="m-title">资质信息[每个类别最多上传4张]</div>
                    <div v-loading="imgLoading" element-loading-text="图片上传中,请稍等....">
                        <el-form-item label="身份证照片" prop="idCards" >
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleidCardsImg"
                            >
						    <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.idCards" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deleteidCards(index)">
                        </el-form-item>
						<br>
                        <el-form-item label="营业执照照片" prop="businessLicenses">
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handlebusinessLicensesImg"
                            >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.businessLicenses" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletebusinessLicenses(index)">
                        </el-form-item>
                        <br />
                        <el-form-item label="经营场所照片" prop="businessPlaces">
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handlebusinessPlacesImg"
                            >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.businessPlaces" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletebusinessPlaces(index)">
                        </el-form-item>
						<br>
                        <el-form-item label="门头照" prop="headSigns">
                            <el-upload
								style="display: contents;"
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleheadSignsImg"
                            >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
                            </el-upload>
							<img v-for="(item,index) in agentForm.headSigns" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deleteheadSigns(index)">
                        </el-form-item>
						<br>
						<el-form-item label="相关交易说明" prop="tradeStatements">
						    <el-upload
								style="display: contents;"
						        class="avatar-uploader"
						        :action="uploadUrl"
						        :show-file-list="false"
						        :on-progress="handleImgLoading"
						        :on-success="handletradeStatementsImg"
						    >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
						    </el-upload>
							<img v-for="(item,index) in agentForm.tradeStatements" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletetradeStatements(index)">
						</el-form-item>
						<br>
						<el-form-item label="交易凭证" prop="tradeReceipts">
						    <el-upload
								style="display: contents;"
						        class="avatar-uploader"
						        :action="uploadUrl"
						        :show-file-list="false"
						        :on-progress="handleImgLoading"
						        :on-success="handletradeReceiptsImg"
						    >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
						    </el-upload>
							<img v-for="(item,index) in agentForm.tradeReceipts" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletetradeReceipts(index)">
						</el-form-item>
						<br>
						<el-form-item label="涉及交易卡照片" prop="tradeCards">
						    <el-upload
								style="display: contents;"
						        class="avatar-uploader"
						        :action="uploadUrl"
						        :show-file-list="false"
						        :on-progress="handleImgLoading"
						        :on-success="handletradeCardsImg"
						    >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
						    </el-upload>
							<img v-for="(item,index) in agentForm.tradeCards" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deletetradeCards(index)">
						</el-form-item>
						<br>
						<el-form-item label="承诺函照片" prop="guarantees">
						    <el-upload
								style="display: contents;"
						        class="avatar-uploader"
						        :action="uploadUrl"
						        :show-file-list="false"
						        :on-progress="handleImgLoading"
						        :on-success="handleguaranteesImg"
						    >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
						    </el-upload>
							<img v-for="(item,index) in agentForm.guarantees" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deleteguarantees(index)">
						</el-form-item>
						<br>
						<el-form-item label="其他" prop="others">
						    <el-upload
								style="display: contents;"
						        class="avatar-uploader"
						        :action="uploadUrl"
						        :show-file-list="false"
						        :on-progress="handleImgLoading"
						        :on-success="handleothersImg"
						    >
						        <img :src="require('../../assets/images/other3x.png')" class="avatar">
						    </el-upload>
							<img v-for="(item,index) in agentForm.others" :src="item" class="avatar-uploader" style="margin-left:10px ;" @click="deleteothers(index)">
						</el-form-item>
                    </div>
                </template>
            </el-form>
            <div style="margin-top:20px">
                <el-button
                    type="primary"
                    :loading="loading"
                    style="font-size: 12px;"
                    @click="handleSubmit(agentForm)"
                >提交</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
			uploadUrl: this.$api.uploadUrl, // 上传图片的地址
			loading: false, // 提交loading
			imgLoading: false, // 上传图片loading
            agentForm: {
				type:"CaseData",
				caseNo:this.$route.query.caseNo,
				mercNum:this.$route.query.mercNum,
				idCards:[],//身份证照片
				businessLicenses:[],//营业执照照片
				businessPlaces:[],//经营场所照片
				headSigns:[],//门头照
				tradeStatements:[],//相关交易说明
				tradeReceipts:[],//交易凭证
				tradeCards:[],//涉及交易卡照片
				guarantees:[],//承诺函照片
				others:[],//其他
            },
        }
    },
    watch: {
        
    },
    created() {

    },
    mounted() {

    },
    methods: {
        handleSubmit(agentForm) { //后台提交
			console.log(agentForm)
			this.loading = true; //防重复
			this.$api.post('export/deal_case_data', agentForm, res => {
				let that = this;
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
						onClose() {
							that.loading = false;
							// that.$router.back();
						}
					});
				} else {
					this.$message({
						type: 'error',
						message: res.msg,
						duration: 1500,
						onClose() {
							that.loading = false;
						}
					});
				}
			})
        },
        handleImgLoading() { // 上传文件时加载loading
            this.imgLoading = true;
        },
		deleteidCards(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.idCards.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.idCards.splice(in1, 1)
			}).catch(() => {})
		},
		deletebusinessLicenses(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.businessLicenses.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.businessLicenses.splice(in1, 1)
			}).catch(() => {})
		},
		deletebusinessPlaces(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.businessPlaces.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.businessPlaces.splice(in1, 1)
			}).catch(() => {})
		},
		deleteheadSigns(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.headSigns.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.headSigns.splice(in1, 1)
			}).catch(() => {})
		},
		deletetradeStatements(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.tradeStatements.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.tradeStatements.splice(in1, 1)
			}).catch(() => {})
		},
		deletetradeReceipts(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.tradeReceipts.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.tradeReceipts.splice(in1, 1)
			}).catch(() => {})
		},
		deletetradeCards(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.tradeCards.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.tradeCards.splice(in1, 1)
			}).catch(() => {})
		},
		deleteguarantees(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.guarantees.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.guarantees.splice(in1, 1)
			}).catch(() => {})
		},
		deleteothers(index){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {let in1=this.agentForm.others.findIndex ((v, i) => {if (index==i) {return true;}});
			    this.agentForm.others.splice(in1, 1)
			}).catch(() => {})
		},
        handleidCardsImg(res) {this.upImg({ res, img: 'idCards' });},
        handlebusinessLicensesImg(res) { this.upImg({ res, img: 'businessLicenses' }); },
        handlebusinessPlacesImg(res) { this.upImg({ res, img: 'businessPlaces' }); },
        handleheadSignsImg(res) { this.upImg({ res, img: 'headSigns' }); },
		handletradeStatementsImg(res) { this.upImg({ res, img: 'tradeStatements' }); },
		handletradeReceiptsImg(res) { this.upImg({ res, img: 'tradeReceipts' }); },
		handletradeCardsImg(res) { this.upImg({ res, img: 'tradeCards' }); },
		handleguaranteesImg(res) { this.upImg({ res, img: 'guarantees' }); },
		handleothersImg(res) { this.upImg({ res, img: 'others' }); },
        upImg(res) { //公用
			if(this.agentForm[res.img].length==4){
				this.$message.error("最多4张");
				this.imgLoading = false;
			}else{ 
				let resData = res.res;
				if (resData.code === 0) {
					this.agentForm[res.img] = this.agentForm[res.img].concat([resData.data.file_url]); //展示路径
				} else {
					//错误提示
					this.$message.error(res.msg);
				}
				this.imgLoading = false;
			}
        },
    }
}
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 22px;
}
.m-title {
    color: #303133;
    font-size: 14px;
    font-weight: 700;
    padding-left: 10px;
    margin: 10px 0;
    border-left: 4px solid #409eff;
}
.line {
    text-align: center;
}
::v-deep .el-input-group__append {
    color: #ffffff;
    font-size: 12px;
    background-color: #409eff;
}
.el-form-item__content .el-input-group {
    vertical-align: middle;
	display: -webkit-inline-box;
}
.avatar-uploader {
    width: 200px;
    height: 130px;
    border-radius: 10px;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload {
	display: contents;
    width: 100%;
    height: 100%;
}
.avatar {
	    width: 200px;
	    height: 130px;
}
</style>
